import { Navigate } from "react-router-dom";
import { accessData, isLogged } from "src/helpers/AppConfig";
import PATHS from "./Paths";

import LoginView from "src/pages/authentication/LoginView";
import DashboardView from "src/pages/panel/dashboard/DashboadView";
import ForgotPasswordView from "src/pages/authentication/ForgotPasswordView";
import ResetPasswordView from "src/pages/authentication/ResetPasswordView";
import RegisterView from "src/pages/authentication/RegisterView";
import ProfileView from "src/pages/panel/profile/ProfileView";
import EditProfileView from "src/pages/panel/profile/EditProfileView";
import NurseryView from "src/pages/panel/nursery/NurseryView";
import ShowNurseryView from "src/pages/panel/nursery/ShowNurseryView";
import KindergartenView from "src/pages/panel/kindergarten/KindergartenView";
import ShowKindergartenView from "src/pages/panel/kindergarten/ShowKindergartenView";
import ChildrenCategoriesView from "src/pages/panel/childrens_categories/ChildrenCategoriesView";
import ApplicationsNurseryMunicicpalityView from "src/pages/panel/municipality_nursery_application/ApplicationsView";
import ApplicationsKindergartenMunicicpalityView from "src/pages/panel/municipality_kindergarten_application/ApplicationsView";
import ApplicationsKindergartenView from "src/pages/panel/applications_kindergarten/ApplicationsKindergartenView";
import ApplicationsNurseryView from "src/pages/panel/applications_nursery/ApplicationsNurseryView";
import ShowApplicationsNurseryView from "src/pages/panel/municipality_nursery_application/ShowApplicationView";
import NotificationsView from "src/pages/panel/notifications/NotificationsView";
import ProtectedRoute from "./ProtectedRoute";
import AgeGroupsView from "src/pages/panel/meal/AgeGroupsView";
import AssortmentView from "src/pages/panel/meal/AssortmentView";
import MenuView from "src/pages/panel/meal/MenuView";
import AllergyView from "src/pages/panel/meal/AllergyView";
import EducationAgeGroupsView from "src/pages/panel/education_programs/EducationAgeGroupsView";
import EducationListView from "src/pages/panel/education_programs/EducationListView";
import EducationProgramEditView from "src/pages/panel/education_programs/EducationProgramEditView";
import RegistrationRequestsView from "src/pages/panel/registration_requests/RegistrationRequestsView";
import ShowRegistrationRequestView from "src/pages/panel/registration_requests/ShowRegistrationRequestView";
import OverviewTransfersKindergartenView from "src/pages/panel/transfers/OverviewTransfersKindergartenView";
import OverviewTransfersNurseryView from "src/pages/panel/transfers/OveerviewTransfersNurseryView";
import OverviewTransfersNurseryKindergartenView from "src/pages/panel/transfers/OverviewTransfersNurseryKindergartenView";
import TransferKindergartenListView from "src/pages/panel/transfers/KindergartenTransfers";
import TransferNurseryListView from "src/pages/panel/transfers/NurseryTransfers";
import RolesView from "src/pages/panel/roles/RolesView";
import TransferNurseryToKindergartenListView from "src/pages/panel/transfers/NurseryToKindergartenTransfersView";
// import TransfersHrView from "src/pages/panel/transfers/TransfersHrView";
import EducationProgramView from "src/pages/panel/education_programs/EducationProgramView";
import ChatView from "src/pages/panel/chat/ChatView";
import ReportsView from "src/pages/panel/reports/ReportsView";
import PerformanceView from "src/pages/panel/performance/PerformanceView";
import TeachersView from "src/pages/panel/teachers/TeachersView";
import ShowTeacherView from "src/pages/panel/teachers/ShowTeacherView";
import ChildrenView from "src/pages/panel/children/ChildrenView";
import BackupView from "src/pages/panel/backup/BackupView";
import LogsView from "src/pages/panel/logs/LogsView";
import ShowChildView from "src/pages/panel/children/ShowChildView";
// import EmailView from "src/pages/panel/email/EmailView";
import GroupsView from "src/pages/panel/groups/GroupsView";
import AddNewGroupView from "src/pages/panel/groups/AddNewGroupView";
import GalleryView from "src/pages/panel/gallery/GalleryView";
import AlbumView from "src/pages/panel/gallery/AlbumView";
import StaffView from "src/pages/panel/staff/StaffView";
import EditGroupView from "src/pages/panel/groups/EditGroupView";
import KindergartenNurseryListView from "src/pages/panel/kindergartennursery/KindergartenNurseryListView";
import ShowKindergartenNurseryView from "src/pages/panel/kindergartennursery/ShowKindergartenNursery";
import ParticipationView from "src/pages/panel/participation/ParticipationView";
import EvaluationsView from "src/pages/panel/evaluations/EvaluationsView";
import MakeApplicationsFirstStepKindergartenView from "src/pages/panel/applications_kindergarten/application_first_step/MakeAppFirstStepKindergartenView";
import MakeApplicationsSecondStepKindergartenView from "src/pages/panel/applications_kindergarten/application_second_step/MakeAppSecondStepKindergartenView";
import MakeApplicationsThirdStepKindergartenView from "src/pages/panel/applications_kindergarten/application_third_step/MakeAppThirdStepKindergartenView";
import EditFirstStepKindergartenView from "src/pages/panel/applications_kindergarten/application_first_step/EditFirstStepKindergartenView";
import EditApplicationsSecondStepKindergartenView from "src/pages/panel/applications_kindergarten/application_second_step/EditSecondStepKindergartenView";
import EditApplicationsThirdStepKindergartenView from "src/pages/panel/applications_kindergarten/application_third_step/EditThirdStepKindergartenView";

import MakeApplicationsFirstStepNurseryView from "src/pages/panel/applications_nursery/application_first_step/MakeAppFirstStepNurseryView";
import MakeApplicationsSecondStepNurseryView from "src/pages/panel/applications_nursery/application_second_step/MakeAppSecondStepNurseryView";
import MakeApplicationsThirdStepNurseryView from "src/pages/panel/applications_nursery/application_third_step/MakeAppThirdStepNurseryView";
import EditFirstStepNurseryView from "src/pages/panel/applications_nursery/application_first_step/EditFirstStepNurseryView";
import EditSecondStepNurseryView from "src/pages/panel/applications_nursery/application_second_step/EditSecondStepNurseryView";
import EditThirdStepNurseryView from "src/pages/panel/applications_nursery/application_third_step/EditThirdStepNurseryView";
import CreateNewAccountView from "src/pages/authentication/CreateNewAccountView";
import CreateNewAccountNationalRegistryView from "src/pages/authentication/CreateNewAccountNationalRegistryView";
import AddRolesView from "src/pages/panel/roles/AddRolesView";
import EditRoleView from "src/pages/panel/roles/EditRoleView";
import HolidaysListView from "src/pages/panel/holidays/HolidaysListView";
import CategoriesDiscountListView from "src/pages/panel/categories_discount/CategoriesDiscountListView";
import FinanceListView from "src/pages/panel/finance/FinanceListView";
import RegisteredSuccessfulyView from "src/pages/authentication/RegisteredSuccessfulyView";

type RouteItem = {
  path: string;
  element: JSX.Element;
};

const checkPrivateRoutes = (route: JSX.Element): JSX.Element => {
  if (!isLogged()) {
    return <Navigate to={PATHS.login} />;
  } else {
    return route;
  }
};

const PrivateRoutes: RouteItem[] = [
  {
    path: PATHS.dashboard,
    element: checkPrivateRoutes(
      <ProtectedRoute
        requiredPermissions={[
          "dashboard-all-children",
          "dashboard-my-children",
        ]}
      >
        <DashboardView />
      </ProtectedRoute>
    ),
  },
  {
    path: PATHS.myProfile,
    element: checkPrivateRoutes(
      <ProtectedRoute requiredPermissions={["profile-edit"]}>
        <ProfileView />
      </ProtectedRoute>
    ),
  },
  {
    path: PATHS.nursery,
    element: checkPrivateRoutes(
      <ProtectedRoute requiredPermissions={["kindergarten-list-all"]}>
        <NurseryView />
      </ProtectedRoute>
    ),
  },
  {
    path: PATHS.showNurseryId,
    element: checkPrivateRoutes(
      <ProtectedRoute requiredPermissions={["kindergarten-show"]}>
        <ShowNurseryView />
      </ProtectedRoute>
    ),
  },
  {
    path: PATHS.kindergarten,
    element: checkPrivateRoutes(
      <ProtectedRoute requiredPermissions={["kindergarten-list-all"]}>
        <KindergartenView />
      </ProtectedRoute>
    ),
  },
  {
    path: PATHS.kindergartenNursery,
    element: checkPrivateRoutes(
      <ProtectedRoute
        requiredPermissions={["kindergarten-list-my-kindergartens"]}
      >
        <KindergartenNurseryListView />
      </ProtectedRoute>
    ),
  },
  {
    path: PATHS.showKindergartenNurseryId,
    element: checkPrivateRoutes(
      <ProtectedRoute
        requiredPermissions={["kindergarten-show-my-kindergartens"]}
      >
        <ShowKindergartenNurseryView />
      </ProtectedRoute>
    ),
  },
  {
    path: PATHS.showKindergartenId,
    element: checkPrivateRoutes(
      <ProtectedRoute requiredPermissions={["kindergarten-show"]}>
        <ShowKindergartenView />
      </ProtectedRoute>
    ),
  },
  {
    path: PATHS.registerApplicationsNursery,
    element: checkPrivateRoutes(
      <ProtectedRoute
        requiredPermissions={[
          "application-list-all",
          "application-list-to-verify",
        ]}
      >
        <ApplicationsNurseryMunicicpalityView />
      </ProtectedRoute>
    ),
  },
  {
    path: PATHS.registerApplicationsKindergarten,
    element: checkPrivateRoutes(
      <ProtectedRoute
        requiredPermissions={[
          "application-list-all",
          "application-list-to-verify",
        ]}
      >
        <ApplicationsKindergartenMunicicpalityView />
      </ProtectedRoute>
    ),
  },
  {
    path: PATHS.showApplicationKindergartenId,
    element: checkPrivateRoutes(
      <ProtectedRoute
        requiredPermissions={[
          "application-show",
          "application-show-to-verify",
          "application-show-my",
          "application-list-to-verify",
        ]}
      >
        <ShowApplicationsNurseryView />
      </ProtectedRoute>
    ),
  },
  {
    path: PATHS.showApplicationNurseryId,
    element: checkPrivateRoutes(
      <ProtectedRoute
        requiredPermissions={[
          "application-show",
          "application-show-to-verify",
          "application-show-my",
          "application-list-to-verify",
        ]}
      >
        <ShowApplicationsNurseryView />
      </ProtectedRoute>
    ),
  },
  {
    path: PATHS.showApplicationsNurseryId,
    element: checkPrivateRoutes(
      <ProtectedRoute
        requiredPermissions={[
          "application-show",
          "application-show-to-verify",
          "application-show-my",
          "application-list-to-verify",
        ]}
      >
        <ShowApplicationsNurseryView />
      </ProtectedRoute>
    ),
  },
  {
    path: PATHS.showApplicationsKindergartenId,
    element: checkPrivateRoutes(
      <ProtectedRoute
        requiredPermissions={[
          "application-show",
          "application-show-to-verify",
          "application-show-my",
          "application-list-to-verify",
        ]}
      >
        <ShowApplicationsNurseryView />
      </ProtectedRoute>
    ),
  },
  {
    path: PATHS.applicationsKindergarten,
    element: checkPrivateRoutes(
      <ProtectedRoute requiredPermissions={["application-list-my"]}>
        <ApplicationsKindergartenView />
      </ProtectedRoute>
    ),
  },
  {
    path: PATHS.applicationsNursery,
    element: checkPrivateRoutes(
      <ProtectedRoute requiredPermissions={["application-list-my"]}>
        <ApplicationsNurseryView />
      </ProtectedRoute>
    ),
  },
  {
    path: PATHS.makeApplicationStepOneKindergarten,
    element: checkPrivateRoutes(
      <ProtectedRoute requiredPermissions={["application-store"]}>
        <MakeApplicationsFirstStepKindergartenView />
      </ProtectedRoute>
    ),
  },
  {
    path: PATHS.makeApplicationStepOneNursery,
    element: checkPrivateRoutes(
      <ProtectedRoute requiredPermissions={["application-store"]}>
        <MakeApplicationsFirstStepNurseryView />
      </ProtectedRoute>
    ),
  },
  {
    path: PATHS.makeApplicationStepTwoIdKindergarten,
    element: checkPrivateRoutes(
      <ProtectedRoute
        requiredPermissions={["application-set-category-to-child"]}
      >
        <MakeApplicationsSecondStepKindergartenView />
      </ProtectedRoute>
    ),
  },
  {
    path: PATHS.makeApplicationStepTwoIdNursery,
    element: checkPrivateRoutes(
      <ProtectedRoute
        requiredPermissions={["application-set-category-to-child"]}
      >
        <MakeApplicationsSecondStepNurseryView />
      </ProtectedRoute>
    ),
  },
  {
    path: PATHS.editApplicationStepOneIdKindergarten,
    element: checkPrivateRoutes(
      <ProtectedRoute requiredPermissions={["application-update-my"]}>
        <EditFirstStepKindergartenView />
      </ProtectedRoute>
    ),
  },
  {
    path: PATHS.editApplicationStepOneIdNursery,
    element: checkPrivateRoutes(
      <ProtectedRoute requiredPermissions={["application-update-my"]}>
        <EditFirstStepNurseryView />
      </ProtectedRoute>
    ),
  },
  {
    path: PATHS.editApplicationStepTwoIdKindergarten,
    element: checkPrivateRoutes(
      <ProtectedRoute
        requiredPermissions={["application-set-category-to-child"]}
      >
        <EditApplicationsSecondStepKindergartenView />
      </ProtectedRoute>
    ),
  },
  {
    path: PATHS.editApplicationStepTwoIdNursery,
    element: checkPrivateRoutes(
      <ProtectedRoute
        requiredPermissions={["application-set-category-to-child"]}
      >
        <EditSecondStepNurseryView />
      </ProtectedRoute>
    ),
  },
  {
    path: PATHS.makeApplicationStepThreeIdKindergarten,
    element: checkPrivateRoutes(
      <ProtectedRoute requiredPermissions={["application-store-docs"]}>
        <MakeApplicationsThirdStepKindergartenView />
      </ProtectedRoute>
    ),
  },
  {
    path: PATHS.makeApplicationStepThreeIdNursery,
    element: checkPrivateRoutes(
      <ProtectedRoute requiredPermissions={["application-store-docs"]}>
        <MakeApplicationsThirdStepNurseryView />
      </ProtectedRoute>
    ),
  },
  {
    path: PATHS.editApplicationStepThreeIdKindergarten,
    element: checkPrivateRoutes(
      <ProtectedRoute requiredPermissions={["application-update-docs"]}>
        <EditApplicationsThirdStepKindergartenView />
      </ProtectedRoute>
    ),
  },
  {
    path: PATHS.editApplicationStepThreeIdNursery,
    element: checkPrivateRoutes(
      <ProtectedRoute requiredPermissions={["application-update-docs"]}>
        <EditThirdStepNurseryView />
      </ProtectedRoute>
    ),
  },

  {
    path: PATHS.transersListNursery,
    element: checkPrivateRoutes(
      <ProtectedRoute
        requiredPermissions={["transfer-list-all", "transfer-list-to-verify"]}
      >
        <OverviewTransfersNurseryView />
      </ProtectedRoute>
    ),
  },
  {
    path: PATHS.transersListKindergarten,
    element: checkPrivateRoutes(
      <ProtectedRoute
        requiredPermissions={["transfer-list-all", "transfer-list-to-verify"]}
      >
        <OverviewTransfersKindergartenView />
      </ProtectedRoute>
    ),
  },
  {
    path: PATHS.transersListNurseryKindergarten,
    element: checkPrivateRoutes(
      <ProtectedRoute
        requiredPermissions={["transfer-list-all", "transfer-list-to-verify"]}
      >
        <OverviewTransfersNurseryKindergartenView />
      </ProtectedRoute>
    ),
  },
  {
    path: PATHS.transersNurseryList,
    element: checkPrivateRoutes(
      <ProtectedRoute requiredPermissions={["transfer-list-my"]}>
        <TransferNurseryListView />
      </ProtectedRoute>
    ),
  },
  {
    path: PATHS.transersKindergartenList,
    element: checkPrivateRoutes(
      <ProtectedRoute requiredPermissions={["transfer-list-my"]}>
        <TransferKindergartenListView />
      </ProtectedRoute>
    ),
  },
  {
    path: PATHS.transfersNurseryToKindergarten,
    element: checkPrivateRoutes(
      <ProtectedRoute requiredPermissions={["transfer-list-my"]}>
        <TransferNurseryToKindergartenListView />
      </ProtectedRoute>
    ),
  },
  // {
  //   path: PATHS.transersList,
  //   element: checkPrivateRoutes(
  //     <ProtectedRoute requiredPermissions={[6]}>
  //       <TransfersHrView />
  //     </ProtectedRoute>
  //   ),
  // },
  {
    path: PATHS.unregistration,
    element: checkPrivateRoutes(
      <ProtectedRoute
        requiredPermissions={[
          "children-unregister-list",
          "children-unregister-list-in-kindergarten",
          "children-unregister-list-my",
        ]}
      >
        <RegistrationRequestsView />
      </ProtectedRoute>
    ),
  },
  {
    path: PATHS.roles,
    element: checkPrivateRoutes(
      <ProtectedRoute requiredPermissions={["role-list"]}>
        <RolesView />
      </ProtectedRoute>
    ),
  },
  {
    path: PATHS.createRole,
    element: checkPrivateRoutes(
      <ProtectedRoute requiredPermissions={["role-store"]}>
        <AddRolesView />
      </ProtectedRoute>
    ),
  },
  {
    path: PATHS.updateRoleId,
    element: checkPrivateRoutes(
      <ProtectedRoute requiredPermissions={["role-update"]}>
        <EditRoleView />
      </ProtectedRoute>
    ),
  },

  {
    path: PATHS.showUnregistrationId,
    element: checkPrivateRoutes(
      <ProtectedRoute
        requiredPermissions={[
          "children-unregister-show",
          "children-unregister-show-in-kindergarten",
        ]}
      >
        <ShowRegistrationRequestView />
      </ProtectedRoute>
    ),
  },
  {
    path: PATHS.notifications,
    element: checkPrivateRoutes(
      <ProtectedRoute requiredPermissions={["profile-edit"]}>
        <NotificationsView />
      </ProtectedRoute>
    ),
  },
  {
    path: PATHS.editProfile,
    element: checkPrivateRoutes(
      <ProtectedRoute requiredPermissions={["profile-update"]}>
        <EditProfileView />
      </ProtectedRoute>
    ),
  },
  {
    path: PATHS.childrensCategories,
    element: checkPrivateRoutes(
      <ProtectedRoute requiredPermissions={["children-category-list"]}>
        <ChildrenCategoriesView />
      </ProtectedRoute>
    ),
  },
  {
    path: PATHS.mealsAgegroups,
    element: checkPrivateRoutes(
      <ProtectedRoute requiredPermissions={["food-age-group-list"]}>
        <AgeGroupsView />
      </ProtectedRoute>
    ),
  },
  {
    path: PATHS.mealsAssortment,
    element: checkPrivateRoutes(
      <ProtectedRoute requiredPermissions={["assortment-list"]}>
        <AssortmentView />
      </ProtectedRoute>
    ),
  },
  {
    path: PATHS.mealsMenu,
    element: checkPrivateRoutes(
      <ProtectedRoute requiredPermissions={["food-menu-list"]}>
        <MenuView />
      </ProtectedRoute>
    ),
  },
  {
    path: PATHS.mealsAllergy,
    element: checkPrivateRoutes(
      <ProtectedRoute
        requiredPermissions={[
          "allergy-group-list",
         
        ]}
      >
        <AllergyView />
      </ProtectedRoute>
    ),
  },
  {
    path: PATHS.mealsAllergyIdProducts,
    element: checkPrivateRoutes(
      <ProtectedRoute requiredPermissions={["allergy-product-list"]}>
        <AllergyView />
      </ProtectedRoute>
    ),
  },
  {
    path: PATHS.educationList,
    element: checkPrivateRoutes(
      <ProtectedRoute requiredPermissions={["education-program-monthly-list"]}>
        <EducationListView />
      </ProtectedRoute>
    ),
  },
  {
    path: PATHS.educationAgeGroups,
    element: checkPrivateRoutes(
      <ProtectedRoute
        requiredPermissions={["education-program-age-group-list"]}
      >
        <EducationAgeGroupsView />
      </ProtectedRoute>
    ),
  },
  {
    path: PATHS.educationEditViewId,
    element: checkPrivateRoutes(
      <ProtectedRoute requiredPermissions={["education-program-daily-store"]}>
        <EducationProgramEditView />
      </ProtectedRoute>
    ),
  },
  {
    path: PATHS.educationEditViewId,
    element: checkPrivateRoutes(
      <ProtectedRoute requiredPermissions={["education-program-daily-store"]}>
        <EducationProgramEditView />
      </ProtectedRoute>
    ),
  },
  {
    path: PATHS.educationViewId,
    element: checkPrivateRoutes(
      <ProtectedRoute requiredPermissions={["education-program-daily-list"]}>
        <EducationProgramView />
      </ProtectedRoute>
    ),
  },
  {
    path: PATHS.gallery,
    element: checkPrivateRoutes(
      <ProtectedRoute
        requiredPermissions={[
          "album-list-my",
          "album-list-in-groups",
          "album-list-in-kindergarten",
        ]}
      >
        <GalleryView />
      </ProtectedRoute>
    ),
  },
  {
    path: PATHS.showAlbumId,
    element: checkPrivateRoutes(
      <ProtectedRoute
        requiredPermissions={[
          "album-edit-in-kindergarten",
          "album-edit-in-groups",
          "album-edit-my",
        ]}
      >
        <AlbumView />
      </ProtectedRoute>
    ),
  },
  {
    path: PATHS.chat,
    element: checkPrivateRoutes(
      <ProtectedRoute requiredPermissions={["message-thread-list"]}>
        <ChatView />
      </ProtectedRoute>
    ),
  },

  {
    path: PATHS.messagesOfIdThreads,
    element: checkPrivateRoutes(
      <ProtectedRoute requiredPermissions={["message-thread-list"]}>
        <ChatView />
      </ProtectedRoute>
    ),
  },
  // {
  //   path: PATHS.email,
  //   element: checkPrivateRoutes(
  //     <ProtectedRoute requiredPermissions={[]}>
  //       <EmailView />
  //     </ProtectedRoute>
  //   ),
  // },
  {
    path: PATHS.staff,
    element: checkPrivateRoutes(
      <ProtectedRoute requiredPermissions={["staff-list"]}>
        <StaffView />
      </ProtectedRoute>
    ),
  },
  {
    path: PATHS.reports,
    element: checkPrivateRoutes(
      <ProtectedRoute
        requiredPermissions={[
          "transfer-reports-list",
          "application-reports-list",
          "transfer-reports-list-in-kindergarten",
          "application-reports-list-in-kindergarten",
        ]}
      >
        <ReportsView />
      </ProtectedRoute>
    ),
  },
  {
    path: PATHS.teachers,
    element: checkPrivateRoutes(
      <ProtectedRoute requiredPermissions={["kindergarten-teacher-list"]}>
        <TeachersView />
      </ProtectedRoute>
    ),
  },
  {
    path: PATHS.showTeacherId,
    element: checkPrivateRoutes(
      <ProtectedRoute
        requiredPermissions={["performance-list-in-kindergarten"]}
      >
        <ShowTeacherView />
      </ProtectedRoute>
    ),
  },
  {
    path: PATHS.performance,
    element: checkPrivateRoutes(
      <ProtectedRoute
        requiredPermissions={[
          "performance-list-in-kindergarten",
          "performance-list-my",
          "performance-teachers-in-kindergarten-list",
          "performance-teachers-in-kindergartens-list",
        ]}
      >
        <PerformanceView />
      </ProtectedRoute>
    ),
  },
  {
    path: PATHS.children,
    element: checkPrivateRoutes(
      <ProtectedRoute
        requiredPermissions={[
          "children-list-in-group",
          "children-list-in-kindergarten",
        ]}
      >
        <ChildrenView />
      </ProtectedRoute>
    ),
  },
  {
    path: PATHS.showChildId,
    element: checkPrivateRoutes(
      <ProtectedRoute
        requiredPermissions={[
          "children-edit-my",
          "children-edit-in-group",
          "children-edit-in-kindergarten",
        ]}
      >
        <ShowChildView />
      </ProtectedRoute>
    ),
  },
  {
    path: PATHS.backup,
    element: checkPrivateRoutes(
      <ProtectedRoute requiredPermissions={["backup-list"]}>
        <BackupView />
      </ProtectedRoute>
    ),
  },
  {
    path: PATHS.logs,
    element: checkPrivateRoutes(
      <ProtectedRoute requiredPermissions={["activity-log-list"]}>
        <LogsView />
      </ProtectedRoute>
    ),
  },
  {
    path: PATHS.groupsList,
    element: checkPrivateRoutes(
      <ProtectedRoute
        requiredPermissions={[
          "kindergartengroup-list-all",
          "kindergartengroup-list-my",
        ]}
      >
        <GroupsView />
      </ProtectedRoute>
    ),
  },
  {
    path: PATHS.addGroup,
    element: checkPrivateRoutes(
      <ProtectedRoute requiredPermissions={["kindergartengroup-store"]}>
        <AddNewGroupView />
      </ProtectedRoute>
    ),
  },
  {
    path: PATHS.editGroupId,
    element: checkPrivateRoutes(
      <ProtectedRoute requiredPermissions={["kindergartengroup-update"]}>
        <EditGroupView />
      </ProtectedRoute>
    ),
  },
  {
    path: PATHS.participation,
    element: checkPrivateRoutes(
      <ProtectedRoute requiredPermissions={["children-list-participation"]}>
        <ParticipationView />
      </ProtectedRoute>
    ),
  },
  {
    path: PATHS.evaluations,
    element: checkPrivateRoutes(
      <ProtectedRoute
        requiredPermissions={["children-list-evaluation-in-group"]}
      >
        <EvaluationsView />
      </ProtectedRoute>
    ),
  },
  {
    path: PATHS.holidays,
    element: checkPrivateRoutes(
      <ProtectedRoute requiredPermissions={["holiday-list"]}>
        <HolidaysListView />
      </ProtectedRoute>
    ),
  },
  {
    path: PATHS.discount,
    element: checkPrivateRoutes(
      <ProtectedRoute requiredPermissions={["discount-list"]}>
        <CategoriesDiscountListView />
      </ProtectedRoute>
    ),
  },
  {
    path: PATHS.finance,
    element: checkPrivateRoutes(
      <ProtectedRoute requiredPermissions={["finance-list"]}>
        <FinanceListView />
      </ProtectedRoute>
    ),
  },
];

const checkPublicRoutes = (route: JSX.Element): JSX.Element => {
  let path = "/";

  const hasPermission = (...permissions: string[]): boolean => {
    const userPermissions = accessData("permissions") || [];
    return permissions.some((permission) =>
      userPermissions.includes(permission)
    );
  };

  // Checking multiple permissions for each path
  if (hasPermission("dashboard-all-children", "dashboard-my-children")) {
    path = PATHS.dashboard;
  } else if (
    hasPermission("children-list-in-group", "children-list-in-kindergarten")
  ) {
    path = PATHS.children;
  } else if (hasPermission("kindergarten-list-my-kindergartens")) {
    path = PATHS.kindergartenNursery;
  } else if (hasPermission("staff-list")) {
    path = PATHS.staff;
  } else if (hasPermission("activity-log-list")) {
    path = PATHS.logs;
  } else if (hasPermission("application-list-all")) {
    path = PATHS.registerApplicationsNursery;
  }

  if (isLogged()) {
    return <Navigate to={path} replace />;
  } else {
    return route;
  }
};

const PublicRoutes: RouteItem[] = [
  {
    path: PATHS.homepage,
    element: <Navigate to={PATHS.login} />,
  },
  {
    path: PATHS.login,
    element: checkPublicRoutes(<LoginView />),
  },
  {
    path: PATHS.forgotPassword,
    element: checkPublicRoutes(<ForgotPasswordView />),
  },
  // {
  //   path: PATHS.createNewAccount,
  //   element: checkPublicRoutes(<CreateNewAccountNationalRegistryView />),
  // },
  {
    path: PATHS.createNewAccount,
    element: checkPublicRoutes(<CreateNewAccountView />),
  },
  {
    path: PATHS.registeredSuccessfullyToken,
    element: checkPublicRoutes(<RegisteredSuccessfulyView />),
  },
  {
    path: PATHS.resetPasswordParam,
    element: checkPublicRoutes(<ResetPasswordView />),
  },
  {
    path: PATHS.activateAccountParam,
    element: checkPublicRoutes(<RegisterView />),
  },
];

export { PrivateRoutes, PublicRoutes };
